import React, {useState, useEffect} from 'react';
import Container from '../Container';
import Content from '../Content';
import Header from '../navbar/Header';
import Navbar from '../navbar/Navbar';
import AddAssignment from './AddAssignment';
import AssignmentList from './AssignmentList';

function AssignmentContainer(props) {
    const [refresh, setRefresh] = useState(false);
    return (
       <Container>
          <Navbar/>

            <Content>
                <Header/>

                {/* <AddAssignment refresh={refresh} setRefresh={setRefresh}/> */}
                <AssignmentList refresh={refresh} setRefresh={setRefresh}/>
            </Content>
       </Container>
    );
}

export default AssignmentContainer;